module.exports = __webpack_public_path__ + "img/img5.b2ef0ebc.png";